import { render, staticRenderFns } from "./AutoDM.vue?vue&type=template&id=9ed56fc2&"
import script from "./AutoDM.vue?vue&type=script&lang=js&"
export * from "./AutoDM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports